<template>
  <v-card class="actions__item">
    <div class="actions__title">
      <span :class="`actions__status ${getStatusColor}`">
         {{item.status_label}}
      </span>
      <span class="section-title">{{ item.title }}</span>
    </div>

    <v-card-text class="py-3 flex-grow-1">
      <div class="actions__desc-wrap" v-if="item.profile_sales && item.profile_sales.length">
        <div class="actions__desc">
          {{ item.short_description }}
        </div>
        <div class="actions__bonuses">
          <div class="actions__bonus" v-for="sale in item.profile_sales" :key="sale.id">
            {{sale.bonuses}} баллов.<br>Дата выплаты: {{sale.paid_day}}
          </div>
        </div>
      </div>
      <template v-else>{{ item.short_description }}</template>
    </v-card-text>

    <v-card-actions class="px-3 actions__btn-bottom">

      <div class="buttons-wrap">
        <!-- v-if="item.pdf_file_url" -->
        <div class="buttons-wrap--button" v-if="item.pdf_file_url">
          <v-btn
            color="secondary2"
            class="buttons-wrap--button"
            @click="showPDF(item.pdf_file_url)"
            block
          >Правила
          </v-btn>
        </div>
        <!-- v-if="item.pdf_detail_file_url" -->
        <div class="buttons-wrap--button" v-if="item.pdf_detail_file_url">
          <v-btn
            color="secondary2"
            class="actions__btn"
            @click="showPDF(item.pdf_detail_file_url)"
            block
          >Список товаров
          </v-btn>
        </div>
      </div>

      <div class="buttons-wrap">
        <div class="buttons-wrap--button" v-if="showActionPhotos && type !== 'archive'">
          <v-btn
            @click="goToDetails"
            block
            color="primary"
            class="actions__btn mb-6"
          >{{isNeedSales ? 'Добавить фото' : 'Подтвердить закупку'}}
            <font-awesome-icon
              icon="file-image"
              class="size-18 ml-2 actions__btn-icon"
              block
            />
          </v-btn>
        </div>

        <div class="buttons-wrap--button" v-if="item.is_actual">
          <v-btn
            @click="addSale(item.id)"
            color="primary"
            class="actions__btn"
            block
          >Создать отчёт
          </v-btn>
        </div>
      </div>

      <!--v-row v-if="item.original_sales_table && isTableShow">
        <v-col cols="12">
          <Table :item="item"/>
        </v-col>
      </v-row>

      <v-row v-if="isTableDescShow">
        <v-col cols="12">
          <div class="actions__table-desc">
            Данные по акции в процессе обработки
          </div>
        </v-col>
      </v-row-->

      <div class="description-row">
        <v-btn @click="showDesc(item.id)" block text>
          Описание
          <font-awesome-icon
            :icon="showDescID === item.id ? 'chevron-up' : 'chevron-down'"
            class="size-18 btn-icon"
          />
        </v-btn>
        <div
          v-if="showDescID && (showDescID === item.id) && item.description"
          class="py-2"
          v-html="item.description"
        />
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import Table from './Table.vue';

export default {
  components: { Table },
  props: ['item', 'showDescID', 'type'],
  data() {
    return {
      isTableShow: false,
      isTableDescShow: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    canConfirm() {
      return !this.$props.item.is_confirmed && this.$props.type !== 'archive';
    },
    isNeedSales() {
      return this.$props.item.need_sales;
    },
    isNeedPhotos() {
      return this.$props.item.need_photos;
    },
    showActionProgress() {
      return !!(this.$props.item.is_confirmed && !this.isNeedSales);
    },
    showActionPhotos() {
      return !!(this.isNeedPhotos || this.isNeedSales) && !this.canConfirm;
    },
    getStatusColor() {
      switch (this.$props.item.status) {
        case 'active': return 'color-green';
        case 'paid': return 'color-green';
        default: return 'color-red';
      }
    },
  },
  methods: {
    showPDF(url) {
      this.$emit('showPDF', url);
    },
    addSale(id) {
      this.$router.push(`/sale/${id}/null`);
    },
    showDesc(id) {
      this.$emit('showDesc', id);
    },
    onTableShow() {
      this.isTableShow = !!(this.$props.item.original_sales_table && !this.isTableShow);
      this.isTableDescShow = !!(!this.$props.item.original_sales_table && !this.isTableDescShow);
    },
    confirmAction(id) {
      this.$store.dispatch('sales/ConfirmAction', {
        profile_id: this.user.profile_id,
        action_id: id,
      });
    },
    goToDetails() {
      this.$router.push(`/actions/${this.$props.item.id}`);
    },
  },
};
</script>

<style scoped lang="scss">
.actions {
  &__title {
    justify-content: space-between;

    @media all and (min-width: 600px) {
      flex-wrap: nowrap;
    }
  }

  &__status-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #ff0000;
    margin-right: 10px;

    &.active {
      background-color: #009b41;
    }

    &.paid {
      background-color: #175789;
    }
  }

  &__desc-wrap {
    @media all and (min-width: 1024px) {
      display: flex;
      flex-direction: column-reverse;
    }
  }

  &__desc {
    padding-bottom: 20px;
    font-weight: 400;

    @media all and (min-width: 1024px) {
      padding: 0;
    }
  }

  &__bonuses {
    @media all and (min-width: 1024px) {
      text-transform: uppercase;
      color: #FF7F45;
      margin-bottom: 15px;
    }
  }

  &__btn-bottom{
    display: flex;
    flex-direction: column;
    align-items: unset;
    gap: 10px;
  }

  .buttons-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    &--button {
      min-width: calc(50% - 10px);
      flex-grow: 1;

      @media all and (max-width: 499px) {
        width: 100%;
      }
    }
  }

  &__status {
    float: right;
    color: #fff;
    line-height: 1;
    min-height: 16px;
    padding: 5px 12px;
    border-radius: 15px;
    display: flex;
    align-items:center;

    &.color-green{background-color: #388e3c}
    &.color-red{background-color: #d32f2f}
  }
}
</style>
